module.exports = "/_next/static/images/uy-3b6078d1b4871adb2f5561305f41626f.svg";